export const Types = {
    START_DELETE_BREAK_TAG: "START_DELETE_BREAK_TAG",
    END_DELETE_BREAK_TAG: "END_DELETE_BREAK_TAG",
    SELECT_TAG_FOR_DELETION: "SELECT_TAG_FOR_DELETION",
    DELETE_SELECTED_TAG: "DELETE_SELECTED_TAG",
    TAG_DELETED: "TAG_DELETED",
    CANCEL_SELECTED_DELETE: "CANCEL_SELECTED_DELETE",
    REQUEST_CONFIRM_DELETED_SELECTED_TAG: "REQUEST_CONFIRM_DELETED_SELECTED_TAG"
};

export const startDeleteBreakTagAction = () => ({
    type: Types.START_DELETE_BREAK_TAG
});

export const endDeleteBreakTagAction = () => ({
    type: Types.END_DELETE_BREAK_TAG
});

export const selectTagForDeletion = (tagLabel) => ({
    type: Types.SELECT_TAG_FOR_DELETION,
    tagLabel
});

export const deleteSelectedTagAction = () => ({
    type: Types.DELETE_SELECTED_TAG
});

export const tagDeletedAction = () => ({
    type: Types.TAG_DELETED
});

export const confirmDeleteSelectedTagAction = (confirmationInfo, confirmation) => ({
    type: Types.REQUEST_CONFIRM_DELETED_SELECTED_TAG,
    confirmationInfo,
    confirmation
});

export const cancelSelectedDeleteAction = () => ({
    type: Types.CANCEL_SELECTED_DELETE
});



// WEBPACK FOOTER //
// ./public/pages/EditBreak/DeleteBreakTagModal/actions.js